const AVATAR_COLORS = [
  '#2481cc',
  '#1a8a4a',
  '#c05621',
  '#6b4ba1',
  '#b33a3a',
  '#1a6b8a',
  '#7a5c1e',
  '#2d6a2d',
];

/**
 * Ism asosida deterministik rang qaytaradi (avatar background uchun).
 */
export function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length] ?? '#2481cc';
}
